import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import Testimonials from "@/components/Testimonials";
import NextPageCta from "@/components/NextPageCta";
import { api } from "@/lib/api";
import { Star, ExternalLink } from "lucide-react";
import { BOOK_URL } from "@/lib/booking";

const REVIEW_LINKS = [
  { name: "Google", href: "https://g.page/r/CbV9TiDlQW8GEAE/review", note: "Leave a Google review" },
  { name: "Facebook", href: "https://www.facebook.com/share/18pdc5wCWY/", note: "Recommend on Facebook" },
  { name: "Instagram", href: "https://www.instagram.com/thepropertycuratorwarwickshire", note: "Tag me on Instagram" },
];

export default function ReviewsPage() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  return (
    <Layout>
      <PageHero
        eyebrow="Reviews"
        title="What clients"
        italic="actually say."
        blurb="Real feedback from landlords, agents, tenants and private homeowners across Warwickshire."
      />

      {testimonials.length > 0 && <Testimonials items={testimonials} />}

      <section className="py-20 sm:py-24 bg-[#0B1215] text-[#F8F9FA] grain relative">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="font-mono-label text-[#FF5A36] mb-5 flex items-center gap-2">
            <Star size={14} className="fill-[#FF5A36]" /> · LEAVE A REVIEW
          </div>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tighter leading-[0.95] mb-4">
            Worked with me?<br /><span className="italic font-light">Say so.</span>
          </h2>
          <p className="text-[#F8F9FA]/70 max-w-xl leading-relaxed mb-10">
            Reviews are the lifeblood of a local trade business — and your honest feedback helps the next landlord, tenant or homeowner make a confident decision. Pick the platform that suits you:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="review-platforms">
            {REVIEW_LINKS.map((r) => (
              <a key={r.name} href={r.href} target="_blank" rel="noopener noreferrer"
                className="group border-2 border-[#F8F9FA]/15 hover:border-[#FF5A36] hover:bg-[#FF5A36]/5 p-6 transition-colors"
                data-testid={`leave-review-${r.name.toLowerCase()}`}>
                <div className="font-mono-label text-[#F8F9FA]/50 group-hover:text-[#FF5A36] mb-2">· {r.name.toUpperCase()}</div>
                <div className="flex items-center justify-between gap-3">
                  <span className="font-display text-xl tracking-tight">{r.note}</span>
                  <ExternalLink size={18} className="opacity-50 group-hover:opacity-100"/>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <NextPageCta href={BOOK_URL} label="Ready to book? →" sub="Live availability on my diary — pick a slot in seconds." />
    </Layout>
  );
}
